import React from "react";
import {useTheme} from "@mui/material/styles";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

export default function Error(props) {
    const theme = useTheme();
    return (
        <Box id="error-container" sx={{padding: theme.spacing(4, 1)}}>
            <Alert severity="error">
                <AlertTitle>Error</AlertTitle>
                {props.message}
            </Alert>
        </Box>
    );
}
